<div>

  @if (hasEntries) {
    <div>
      <!-- Data table -->
      <p-table #dt [value]="entries" [scrollable]="true" scrollHeight="500px" [resizableColumns]="true">
        <ng-template pTemplate="header">
          <tr>
            <th pResizableColumn pSortableColumn="networkName">
              Network
              <p-sortIcon field="networkName"></p-sortIcon>
            </th>
            <th pResizableColumn pSortableColumn="sourceUserName">
              Owner
              <p-sortIcon field="sourceUserName"></p-sortIcon>
            </th>
            <th pResizableColumn pSortableColumn="shareTargetName">
              Shared With
              <p-sortIcon field="shareTargetName"></p-sortIcon>
            </th>
            <th pResizableColumn pSortableColumn="shareTargetType">
              Type
              <p-sortIcon field="shareTargetType"></p-sortIcon>
            </th>
            <th pResizableColumn pSortableColumn="accessType">
              Access
              <p-sortIcon field="accessType"></p-sortIcon>
            </th>
            <th>
            </th>
          </tr>
          <tr>
            <th>
              <input pInputText type="text" (input)="dt.filter($event.target.value, 'networkName', 'contains')"
                style="width: 100%;">
              </th>
              <th>
                <input pInputText type="text" (input)="dt.filter($event.target.value, 'sourceUserName', 'contains')"
                  style="width: 100%;">
                </th>
                <th>
                  <input pInputText type="text" (input)="dt.filter($event.target.value, 'shareTargetName', 'contains')"
                    style="width: 100%;">
                  </th>
                  <th>
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'shareTargetType', 'contains')"
                      style="width: 100%;">
                    </th>
                    <th>
                      <input pInputText type="text" (input)="dt.filter($event.target.value, 'accessType', 'contains')"
                        style="width: 100%;">
                      </th>
                      <th>
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-rowData>
                    <tr>
                      <td>
                        <span class="uv-table-value">{{rowData.networkName}}</span>
                      </td>
                      <td>
                        <span class="uv-table-value">{{rowData.sourceUserName}}</span>
                      </td>
                      <td>
                        <span class="uv-table-value">{{rowData.shareTargetName}}</span>
                      </td>
                      <td>
                        <span class="uv-table-value">{{rowData.shareTargetType}}</span>
                      </td>
                      <td>
                        <span class="uv-table-value">{{rowData.accessType}}</span>
                      </td>
                      <td>
                        <button type="button" class="btn btn-danger" title="Unshare this network"
                          [disabled]="rowData.shareTargetType == 'Group'" (click)="deleteShare(rowData.tag.share)">
                          <i class="pi pi-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            }

            @if (!hasEntries) {
              <div style="font-family: 'Roboto', 'Trebuchet MS', Arial, Helvetica, sans-serif; font-size: large; margin: 20px 0px 30px 15px;">
                None
              </div>
            }

          </div>
